import React, {useState, useEffect} from 'react';
import {Dropdown} from './Dropdown';
import {css} from '@emotion/react';
import {ReactComponent as Tail} from '~/static/svg/toolbar/tail.svg';

export const Tooltip = ({
  className,
  children,
  parentRef,
  onHover,
  distance = 20,
  alignTop,
  alignBottom,
  alignRight,
  alignCenter,
  positionRight,
  positionLeft,
}) => {
  const [visible, setVisible] = useState(!onHover);

  useEffect(() => {
    const element = parentRef.current;

    if (!onHover || !element) {
      return undefined;
    }

    const onMouseEnter = () => {
      setVisible(true);
    };
    const onMouseLeave = () => {
      setVisible(false);
    };

    element.addEventListener('mouseenter', onMouseEnter);
    element.addEventListener('mouseleave', onMouseLeave);

    return () => {
      element.removeEventListener('mouseenter', onMouseEnter);
      element.removeEventListener('mouseleave', onMouseLeave);
    };
  }, [onHover, parentRef]);

  return (
    visible && (
      <Dropdown
        className={className}
        parentRef={parentRef}
        alignTop={alignTop}
        alignCenter={alignCenter}
        alignRight={alignRight}
        positionRight={positionRight}
        positionLeft={positionLeft}
        alignBottom={alignBottom}
        distance={distance}
        css={css`
          pointer-events: none;
          overflow: visible;
        `}
      >
        <div
          className="tooltip"
          css={css`
            line-height: 1.5;
            white-space: nowrap;
            padding: 0.75em 1em;
            border-radius: 10px;
            background: #1C1C1E;
            box-shadow: 0 0 0 1px #606060;
            color: #fff;
            text-align: center;
            overflow: visible;
          `}
        >
          {children}
          <Tail
            css={positionRight && css`
                position: absolute;
                top: 50%;
                right: 100%;
                transform: translateY(-50%) translateX(11px) rotate(90deg);
              ` || positionLeft && css`
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%) translateX(-11px) rotate(-90deg);
              ` || alignTop && css`
                position: absolute;
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
              ` || css`
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%) rotate(180deg);
              `}
          />
        </div>
      </Dropdown>
    )
  );
};
